import router from './router';
import menuDev from './menu.dev';
import axios from 'axios';
import initContent from './assets/js/init'

export default {
    // 必填 new Router({....})
    router: router,
    // axios baseURL
    baseURL: process.env.VUE_APP_URL,
    // true: 上汽通用汽车经销商管理系统 false: 上汽通用汽车管理系统 默认: false
    // 'isDmsEnd': process.env.VUE_APP_IS_DMS_END,
    isDmsEnd: false,
    // qa和生产 必填  中台区分项目的唯一标示
    'x-app-code': process.env.VUE_APP_X_CODE,
    // 版本 用于版本过期禁止访问后台，中台没有开启可以不需要
    'x-app-version': process.env.VUE_APP_VERSION,
    // 左目录 本地需要
    /**
    menu: [{
      label: "首页",
      url: "/dashboard",
      icon: 'home-icon'
    }]
  */
    menu: menuDev.menu,
    // top目录 本地需要
    /**
    navBarList: [{
      label: "通用汽车",
      children:[
          {appLabel: "凯迪拉克", appUrl: "http://kaidilake.com"}
      ]
    }]

  */
    navBarList: menuDev.topMenu,
    // 本地需要
    'x-user-code': process.env.VUE_APP_USER_CODE,
    // 本地需要
    'x-user-name': process.env.VUE_APP_USER_NAME,
    // 经销商 本地需要
    'x-position-code': process.env.VUE_APP_POSITION_CODE,
    // 经销商 本地需要
    'x-dealer-code': process.env.VUE_APP_DEADER_CODE,
    // 仅限dealer网关 本地需要
    'x-store-code': process.env.VUE_APP_STORE_CODE,
    // 仅限dealer网关 本地需要
    'x-sale-code': process.env.VUE_APP_SALE_CODE,
    // 仅限dealer网关 本地需要
    'x-service-code': process.env.VUE_APP_SERVICE_CODE,
    // 认证完后的回调，如需认证完后执行方法
    callback: (next) => {
        axios.interceptors.request.use((config) => {
            config.headers.System = process.env.VUE_APP_SYSTEM;
            return config;
        }, (error) => {
            return Promise.reject(error);
        });
        initContent.init(next)
        //next(); // 必写
    }

};
